import { getUser } from 'localStorage/authStorage';
import { UserType } from '../enums/user-management.enum';

export const isDriverUser = (): boolean => {
	const user = getUser();
	if (!user) {
		return false;
	}

	if (user.type === UserType.DRIVER) {
		return true;
	}

	const token = localStorage.getItem('access_token');
	if (token) {
		try {
			const payload = JSON.parse(atob(token.split('.')[1]));
			return payload.type === UserType.DRIVER;
		} catch {
			return false;
		}
	}

	return false;
};
